import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSprinklers = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5089 2H2.99004C2.66665 2 2.40479 2.24849 2.40479 2.55536V3.01211C2.40479 3.31898 2.66665 3.56747 2.99004 3.56747H4.58703V4.35239C4.58703 4.36896 4.58786 4.38553 4.58953 4.40209C4.57373 4.55908 4.62943 4.72079 4.75579 4.84149L5.42003 5.47179C5.64532 5.68557 6.01027 5.68557 6.23556 5.47179C6.46086 5.25801 6.46086 4.9117 6.23556 4.69792L5.74009 4.22775V3.56747H7.65714V6.55017H6.55729C6.20564 6.55017 5.49568 7.22228 5.49568 7.55597C5.49568 7.88966 6.20564 7.79105 6.55729 7.79105H9.85352C10.2052 7.79105 10.9151 7.89045 10.9151 7.55597C10.9151 7.22149 10.2052 6.55017 9.85352 6.55017H8.81103V3.56826H10.7281V4.15439L10.1545 4.6987C9.92917 4.91249 9.92917 5.2588 10.1545 5.47258C10.3798 5.68636 10.7447 5.68636 10.97 5.47258L11.6342 4.84228C11.6716 4.80678 11.7032 4.76655 11.7282 4.72474C11.8229 4.62692 11.882 4.49675 11.882 4.35397V3.56905H13.5097C13.8331 3.56905 14.095 3.32056 14.095 3.01369V2.55694C14.095 2.25007 13.8331 2.00158 13.5097 2.00158L13.5089 2Z",
			fill: "#2C3F81"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.06107 9.12891C6.06107 9.12891 3.23953 9.63141 4.39342 10.7705C5.38354 11.7479 6.06107 9.12891 6.06107 9.12891Z",
			fill: "#2C3F81"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3862 9.03418C10.3862 9.03418 10.5816 11.7518 11.9084 10.7989C13.0482 9.98082 10.3862 9.03418 10.3862 9.03418Z",
			fill: "#2C3F81"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9595 12.3752C10.9595 12.3752 10.2071 15.0037 11.79 14.5154C13.1492 14.0958 10.9595 12.3752 10.9595 12.3752Z",
			fill: "#2C3F81"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3735 11.6233C13.3735 11.6233 14.3204 14.195 15.3338 12.9423C16.2042 11.8671 13.3735 11.6233 13.3735 11.6233Z",
			fill: "#2C3F81"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.38632 12.4556C5.38632 12.4556 3.09268 14.0932 4.65808 14.6289C6.00234 15.0888 5.38632 12.4556 5.38632 12.4556Z",
			fill: "#2C3F81"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.06884 9.2915C8.06884 9.2915 6.54334 11.5989 8.20767 11.5682C9.63673 11.5413 8.06884 9.2915 8.06884 9.2915Z",
			fill: "#2C3F81"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.06884 12.7231C8.06884 12.7231 6.54334 15.0306 8.20767 14.9998C9.63673 14.973 8.06884 12.7231 8.06884 12.7231Z",
			fill: "#2C3F81"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.94486 11.5847C2.94486 11.5847 0.123318 12.0872 1.27721 13.2263C2.26732 14.2037 2.94486 11.5847 2.94486 11.5847Z",
			fill: "#2C3F81"
		})
	]
});
export default SvgSprinklers;
